/**
 * Type-safe localStorage utilities
 */

import { type StorageKey } from '@/shared/config';

export const storage = {
  get: (key: StorageKey): string | null => {
    return localStorage.getItem(key);
  },

  set: (key: StorageKey, value: string): void => {
    localStorage.setItem(key, value);
  },

  remove: (key: StorageKey): void => {
    localStorage.removeItem(key);
  },

  getJSON: <T>(key: StorageKey): T | null => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch {
      return null;
    }
  },

  setJSON: <T>(key: StorageKey, value: T): void => {
    localStorage.setItem(key, JSON.stringify(value));
  },
} as const;
